var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-app-bar",
        {
          attrs: {
            flat: "",
            color: "primary",
            "aria-label": _vm.$t("components.transactions.packs.title"),
          },
        },
        [
          _c("v-toolbar-title", [
            _vm._v(_vm._s(_vm.$t("components.transactions.packs.title"))),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          role: "table",
          "aria-label": _vm.$t("components.transactions.packs.title"),
          headers: _vm.headers,
          items: _vm.transactionsFormatted,
          loading: _vm.isLoading,
          "loading-text": "Loading... Please wait",
          "no-results-text": "No transactions was found",
          "no-data-text": "No data was found",
          "item-key": "orderId",
          color: "secondary",
          "sort-by": "created",
          "group-desc": "",
          "footer-props": {
            showFirstLastPage: true,
            firstIcon: "fad fa-chevron-double-left",
            lastIcon: "fad fa-chevron-double-right",
            prevIcon: "fad fa-chevron-left",
            nextIcon: "fad fa-chevron-right",
          },
        },
        scopedSlots: _vm._u([
          {
            key: "progress",
            fn: function () {
              return [
                _c("v-progress-linear", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isLoading,
                      expression: "isLoading",
                    },
                  ],
                  attrs: {
                    "aria-busy": _vm.isLoading,
                    color: "accent",
                    indeterminate: "",
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function (ref) {
              var items = ref.items
              return [
                _c(
                  "tbody",
                  _vm._l(items, function (item) {
                    return _c("tr", { key: item.orderId }, [
                      _c("td", [_vm._v(_vm._s(item.orderId || "0"))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.charName || "None"))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.packName || "None"))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.perPackPrice || 0))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.amount || 0))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.totalPrice || 0))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.status || "Unknown"))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.created || ""))]),
                      _vm._v(" "),
                      _c("td", [
                        item.pdfLink
                          ? _c(
                              "a",
                              {
                                staticClass: "link-accent",
                                attrs: {
                                  target: "_blank",
                                  rel: "noopener",
                                  "aria-label":
                                    _vm.$t("components.transactions.download") +
                                    " (Order " +
                                    item.orderId +
                                    ")",
                                  href: item.pdfLink,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("components.transactions.download")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "link-accent",
                                attrs: {
                                  target: "_blank",
                                  rel: "noopener",
                                  "aria-disabled": "true",
                                  "aria-label":
                                    _vm.$t(
                                      "components.transactions.unavailable"
                                    ) +
                                    " (Order " +
                                    item.orderId +
                                    ")",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "components.transactions.unavailable"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }